import { Box, FormHelperText } from "@mui/material";

const ErrorMessageHandle = ({ error }: any) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      {error && <FormHelperText error={true}>{error?.message}</FormHelperText>}
    </Box>
  );
};
export default ErrorMessageHandle;
